import React, { PureComponent } from 'react';
import { Modal } from '@carvana/modal';
import { take } from 'ramda';
import { ContentReviewSectionSeparator } from '../Review/styles';

import { ReviewStars } from '../Review/ReviewStars';

import {
  ContentReviewCustomerName,
  ContentReviewArea,
  ContentReviewDate,
  ContentReviewCustomerVehicleLocationWrapper,
  ContentReviewCustomerVehicle,
  ContentReviewCustomerLocation,
  ContentReviewBody,
  ContentReviewStars,
  ReviewStarsText,
  ReviewModalWrapper
} from './styles';

interface ReviewModalProps {
  onClose();
  isOpen: boolean;
  text: string;
  name: string;
  location: string;
  score: string;
  date: string;
  year: string;
  make: string;
  model: string;
}

class ReviewModal extends PureComponent<
  ReviewModalProps,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any
> {
  toggleModal = () => {
    const { onClose } = this.props;

    onClose();
  };

  render() {
    const {
      isOpen,
      text,
      name,
      location,
      score,
      date,
      year,
      make,
      model
    } = this.props;
    const vehicle = `${year} ${make} ${model}`;
    const reviewTextModified =
      text.length > 1000 ? `${take(1000, text)}...` : text;

    return (
      <>
        <ReviewModalWrapper>
          <Modal
            toggleModal={() => this.toggleModal()}
            disableBackdropClick={false}
            fullscreenOnMobile
            open={isOpen}
            headerText=""
            modalTestName="review-modal"
          >
            <ContentReviewArea isModal>
              <ContentReviewCustomerName isModal>
                {name}
              </ContentReviewCustomerName>
              <ContentReviewDate isModal>{date}</ContentReviewDate>
              <ContentReviewCustomerVehicleLocationWrapper>
                <ContentReviewCustomerVehicle>
                  {`${vehicle}`}
                </ContentReviewCustomerVehicle>
                <ContentReviewCustomerLocation>
                  {location}
                </ContentReviewCustomerLocation>
              </ContentReviewCustomerVehicleLocationWrapper>
              <ContentReviewBody restrictHeight={false}>
                {reviewTextModified}
              </ContentReviewBody>
              <ContentReviewSectionSeparator />
              <ContentReviewStars>
                {
                  <>
                    <ReviewStarsText>
                      {`${parseFloat(score).toFixed(1)} OUT OF 5`}
                    </ReviewStarsText>
                    <ReviewStars score={score} />
                  </>
                }
              </ContentReviewStars>
            </ContentReviewArea>
          </Modal>
        </ReviewModalWrapper>
      </>
    );
  }
}

export default ReviewModal;
